import React, { useState } from 'react';
import InfoField from './InfoField';
import { FiEye } from 'react-icons/fi';
import PdfPreviewModal from '../../ClientModule/PdfPreviewModal';
import { getS3key } from '../../../services/employee/api';

const EmploymentDetailsSection = ({ employmentChecks, attachmentResponses }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewType, setPreviewType] = useState(null);
  const isImageUrl = (url) => {
    if (!url) return false;
    return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);
  };

  const handlePreview = async (fileKey) => {
  if (!fileKey) return;
  try {
    let file = fileKey.split(".com/")[1];
    file = decodeURIComponent(file);
    const response = await getS3key(file);
    const isPdf = file.toLowerCase().endsWith(".pdf");
    const blob = new Blob([response.data], {
      type: isPdf ? "application/pdf" : "image/jpeg"
    });
    const blobUrl = URL.createObjectURL(blob);
    setPreviewUrl(blobUrl);
    setPreviewType(isPdf ? "pdf" : "image");
  } catch (error) {
    console.error("Preview failed:", error);
  }
};

  const closeImageModal = () => {
    setShowImageModal(false);
    setCurrentImage('');
  };

  // Determine which data source to use
  const hasEmploymentChecks = employmentChecks && employmentChecks.length > 0;
  const hasAttachmentResponses = attachmentResponses && attachmentResponses.length > 0;

  // Nothing to show at all
  if (!hasEmploymentChecks && !hasAttachmentResponses) {
    return (
      <div className="report-section">
        <h2 className="section-title">Employment Details</h2>
        <p>No employment details available.</p>
      </div>
    );
  }

  // ─── RENDER FROM employmentCheck (primary) ───────────────────────────────
  if (hasEmploymentChecks) {
    return (
      <div className="admin-report-section">
        <h2 className="admin-section-title">Employment Details</h2>
        {employmentChecks.map((emp, index) => {

          return (
            <div key={index} className="employment-entry-card">
              <h3>Employment Entry {index + 1}</h3>
              <div className="grid-container">
                <InfoField label="Employee Code" value={emp.employeeCode || 'N/A'} />
                <InfoField label="Company Name" value={emp.companyName || 'N/A'} />
                <InfoField label="Job Title" value={emp.jobTitle || 'N/A'} />
                <InfoField label="Location" value={emp.location || 'N/A'} />
                <InfoField label="HR Contact Number" value={emp.hrContactNumber || 'N/A'} />
                <InfoField label="HR Contact Email" value={emp.hrContactEmail || 'N/A'} />
                <InfoField label="Working From" value={emp.workingFrom || 'N/A'} />
                <InfoField label="Working To" value={emp.workingTo || 'N/A'} />
                <InfoField label="Remarks" value={emp.remarks || 'N/A'} />
                <InfoField label="Individual Status" value={emp.individualStatus || 'N/A'} />

                {emp.employmentProofFileName ? (
                  <InfoField
                    label="Employment Proof"
                    value={
                      <div className="file-preview-container">
                        <button
                          className="preview-btn"
                          onClick={() => handlePreview(emp.employmentProofFileName)}
                        >
                          <FiEye className="preview-icon" /> View File
                        </button>
                      </div>
                    }
                  />
                ) : (
                  <InfoField label="Employment Proof" value="N/A" />
                )}
              </div>
            </div>
          );
        })}

        {showImageModal && (
          <div className="image-modal-overlay" onClick={closeImageModal}>
            <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
              <span className="image-modal-close" onClick={closeImageModal}>&times;</span>
              <img src={currentImage} alt="Large View" className="large-image" />
            </div>
          </div>
        )}

        {previewUrl && (
  <PdfPreviewModal
    fileUrl={previewUrl}
    fileType={previewType}
    onClose={() => setPreviewUrl(null)}
  />
)}
      </div>
    );
  }

  // ─── FALLBACK: RENDER FROM attachmentResponses ────────────────────────────
  return (
    <div className="admin-report-section">
      <h2 className="admin-section-title">Employment Details</h2>
      {attachmentResponses.map((att, index) => {

        return (
          <div key={index} className="employment-entry-card">
            <h3>Employment Entry {index + 1}</h3>
            <div className="grid-container">
              <InfoField label="Candidate ID" value={att.candidateId || 'N/A'} />
              <InfoField label="Company Name" value={att.companyName || 'N/A'} />
              <InfoField label="Employee Code" value={att.employeeCode || 'N/A'} />
              <InfoField label="Verification Status" value={att.isVerified || 'N/A'} />
              <InfoField label="Remarks" value={att.remarks || 'N/A'} />

              {/* filename is a direct URL (S3 link) */}
              {att.filename ? (
                <InfoField
                  label="Employment Proof"
                  value={
                    <div className="file-preview-container">
                      <button
                        className="preview-btn"
                        onClick={() => handlePreview(att.filename)}
                      >
                        <FiEye className="preview-icon" /> View File
                      </button>
                    </div>
                  }
                />
              ) : (
                <InfoField label="Employment Proof" value="N/A" />
              )}

              {/* fileUrl is an array of base64 images */}
              {/* {att.fileUrl && att.fileUrl.length > 0 && (
                <InfoField
                  label="Additional Files"
                  value={
                    <div className="file-preview-container">
                      {att.fileUrl.map((url, fileIndex) => (
                        <button
                          key={fileIndex}
                          className="preview-btn"
                          style={{ marginRight: '8px', marginBottom: '4px' }}
                          onClick={() => handlePreview(url)}
                        >
                          <FiEye className="preview-icon" /> View File {fileIndex + 1}
                        </button>
                      ))}
                    </div>
                  }
                />
              )} */}
            </div>
          </div>
        );
      })}

      {showImageModal && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="image-modal-close" onClick={closeImageModal}>&times;</span>
            <img src={currentImage} alt="Large View" className="large-image" />
          </div>
        </div>
      )}

      {previewUrl && (
  <PdfPreviewModal
    fileUrl={previewUrl}
    fileType={previewType}
    onClose={() => setPreviewUrl(null)}
  />
)}
    </div>
  );
};

export default EmploymentDetailsSection;